import { ClientDto } from 'src/app/models/client/client-dto';
import { NotificationRuleWorkItemDto } from 'src/app/models/notification/notification-rule-work-item-dto';
import { OrganizationDto } from 'src/app/models/organization.dto';
import { ProcessElementDto } from 'src/app/models/process/process-element-dto';
import { CloneService } from 'src/app/services/local/clone.service';
import { NotificationRulesMetadataValues } from './notification-rules-metadata-values';

export class NotificationRuleWorkItemWrapper {
  initialRule: NotificationRuleWorkItemDto;

  id: string;
  name: string;
  processNodes: ProcessElementDto[];
  clients: ClientDto[];
  statuses: number[];
  organizations: OrganizationDto[];

  private _hasChanges: boolean;

  get hasChanges(): boolean {
    return this._hasChanges;
  }

  set hasChanges(value: boolean) {
    this._hasChanges = value;
  }

  public static createFrom(
    rule: NotificationRuleWorkItemDto | null,
    metadataValues: NotificationRulesMetadataValues | null,
    cloneService: CloneService
  ): NotificationRuleWorkItemWrapper {
    const result = new NotificationRuleWorkItemWrapper();

    const clients =
      rule.clientIds.length > 0
        ? metadataValues?.clients?.filter(c => rule.clientIds.includes(c.id))
        : [];

    const processNodes =
      rule.processNodeIds.length > 0
        ? metadataValues?.processNodes?.filter(pn =>
            rule.processNodeIds.includes(pn.compositeId)
          )
        : [];

    const statuses = rule.statuses ?? [];

    result.initialRule = cloneService.deepClone(rule);

    result.id = rule.id;
    result.name = rule.name;
    result.clients = cloneService.deepClone(clients);
    result.processNodes = cloneService.deepClone(processNodes);
    result.statuses = cloneService.deepClone(statuses);
    result.hasChanges = false;

    return result;
  }
}
